/** Column keys treated as status (always placed immediately before actions). */
export const STATUS_COLUMN_KEYS = new Set(['status', 'statut', 'state']);

/** Column keys treated as actions (always last). */
export const ACTIONS_COLUMN_KEYS = new Set(['actions', 'action']);

/**
 * Split list columns so status can render adjacent to actions.
 * @returns {{ dataColumns: object[], statusColumn: object|null }}
 */
export function partitionStatusFromColumns(columns = []) {
  const dataColumns = [];
  let statusColumn = null;

  columns.forEach((col) => {
    if (STATUS_COLUMN_KEYS.has(col.key) || col.type === 'status') {
      statusColumn = col;
      return;
    }
    if (ACTIONS_COLUMN_KEYS.has(col.key) || col.type === 'actions') {
      return;
    }
    dataColumns.push(col);
  });

  return { dataColumns, statusColumn };
}

/** Ensure status column definition sits right before actions in column picker arrays. */
export function ensureStatusBeforeActions(columns = []) {
  const { dataColumns, statusColumn } = partitionStatusFromColumns(columns);
  const trailing = [];
  if (statusColumn) trailing.push(statusColumn);
  const actionsCol = columns.find(
    (c) => ACTIONS_COLUMN_KEYS.has(c.key) || c.type === 'actions',
  );
  if (actionsCol) trailing.push(actionsCol);
  return [...dataColumns, ...trailing];
}
